module.exports = __webpack_public_path__ + "img/3.9bd58584.jpg";